import React from "react";
import * as PropTypes from "prop-types";

export const StreamBankAutoCompleteItem = React.forwardRef((props, ref) => {
	
	const {className = '', isHighlighted = false, item = {}, key = null, title = null, subtitle = null} = props;
	
	return <div
		{...props}
		className={"sb-autocomplete-item " + (isHighlighted ? "item-highlighted" : "") + ` ${className}`}
		ref={ref}
	>
		{props?.icon}
		<div>
			<div className="title">{title ?? item?.name ?? 'N/A'}</div>
			{subtitle != null ? <div className="subtitle">{subtitle}</div> : null}
		</div>
	</div>;
});

StreamBankAutoCompleteItem.propTypes = {
	className: PropTypes.string,
	isHighlighted: PropTypes.any,
	item: PropTypes.any
};
